import React from 'react';
import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';

/**
 * Status of a subsidized price: orange while it still delivers, blue once its
 * value is dropped to zero.
 *
 * @param {boolean} suspended - no promised shows left
 */
const SubsidizedStatusTag = ({ suspended }) => {
  const { t } = useTranslation();

  return (
    <Tag className="tag-status-display" color={suspended ? 'blue' : 'orange'}>
      {suspended ? t('Suspended') : t('Subsidized')}
    </Tag>
  );
};

export default SubsidizedStatusTag;
